<template>
  <v-container fluid>
    <v-toolbar flat class="mb-3">
      <v-toolbar-title>{{ cliente.nombre }}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container>
      <div v-if="loader">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </div>
      <div v-else>
        <pdf src="./path/to/static/relativity.pdf"></pdf>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.nombre"
                label="Razón social"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.rfc"
                label="RFC"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.correo"
                label="Correo"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.telefono"
                label="Celular de Contacto"
                readonly
                prepend-icon="mdi-cellphone-basic"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cantidad_guias"
                label="Folios Disponibles"
                readonly
                prepend-icon="mdi-cube-send"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.contrasena"
                ref="txtContrasena"
                label="Contreseña"
                :readonly="!modificar_formulario"
                prepend-icon="mdi-form-textbox-password"
                :type="show_password ? 'text' : 'password'"
                :append-outer-icon="
                  modificar_formulario ? 'mdi-content-save' : 'mdi-account-edit'
                "
                @click:append-outer="modificar()"
                :loading="loading_modificar"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
              <v-switch
                id="switch-contrato"
                v-model="modificar_contrato"
                label="Imprimir con contrato"
                color="primary"
                prepend-icon="mdi-file-document-edit"
                inset
                @change="validarCambioContrato"
              ></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-container>
    <v-dialog v-model="dialog_mensaje" max-width="320">
      <v-card>
        <v-card-title class="text-h5 text-center">
          {{ titulo }}
        </v-card-title>

        <v-card-text>
          {{ mensaje }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog_mensaje = false">
            Entendido
          </v-btn>

          <v-btn color="green darken-1" text @click="dialog_mensaje = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_mensaje_contrato" max-width="320">
      <v-card id="dialog-confirmacion-contrato">
        <v-card-title class="text-h5 text-center">
          {{ titulo }}
        </v-card-title>

        <v-card-text>
          {{ mensaje }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="confirmarDialogo()"
          >
            Confirmar
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="cancelarDialogo()"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_error" max-width="340">
      <v-card rounded="xl">
        <v-card-title class="d-flex align-center error--text">
          <v-icon color="error" class="mr-2">
            mdi-alert-circle-outline
          </v-icon>

          Error
        </v-card-title>

        <v-card-text class="grey--text text--darken-1">
          {{ mensaje_error }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            text
            @click="dialog_error = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import service from "@/core/Servicio.js";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export default {
  data: () => ({
    cantidad_guias: 0,
    show_password: false,
    loader: true,

    modificar_formulario: false,

    modificar_contrato: false,
    modificar_contrato_original: false,

    dialog_mensaje_contrato: false,

    titulo: "",
    mensaje: "",

    accion_pendiente: null,

    dialog_mensaje: false,
    dialog_error: false,
    mensaje_error: "",

    loading_modificar: false,

    // 🆕 Nuevas propiedades para control del tour
    tourPending: false,
    initializationComplete: false,

    cliente: {
      nombre: localStorage.getItem("nombre"),
      correo: localStorage.getItem("correo"),
      rfc: localStorage.getItem("rfc"),
      direccion: localStorage.getItem("direccion"),
      telefono: localStorage.getItem("telefono"),
      contrasena: "",
      contrato: localStorage.getItem("contrato"),
    },
  }),
  created() {
    this.initialize();
  },
  mounted() {
    this.$nextTick(() => {
      let tour_completado = localStorage.getItem("tour_completado") || "0";
      let requiere_tour = localStorage.getItem("requiere_tour") || "0";
      if (localStorage.getItem("tour_contrato") == "1"  && tour_completado !== "1" && requiere_tour == "1") {
        this.tourPending = true;
        this.tryStartTour();
      }
    });
  },
  methods: {
    tryStartTour() {
      if (this.tourPending && this.initializationComplete && !this.loader) {
        this.tourPending = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.iniciarTourContrato();
          }, 300);
        });
      }
    },

    validarCambioContrato(valorNuevo) {
      if (valorNuevo === this.modificar_contrato_original) {
        return;
      }

      this.titulo = "Confirmar cambio";
      this.mensaje = "¿Deseas cambiar el estado de aceptación del contrato?";

      this.dialog_mensaje_contrato = true;

      this.accion_pendiente = async () => {
        try {
          let params = {
            cliente_id: localStorage.getItem("id"),
            contrato: valorNuevo ? 1 : 0,
          };

          const response = await service.modificarContrato(params);

          if (response.data.response_flag == 1) {
            this.modificar_contrato_original = valorNuevo;
            this.dialog_mensaje = true;
            this.titulo = "Correcto";
            this.mensaje = response.data.response;
            localStorage.setItem("contrato", valorNuevo ? 1 : 0);
          } else {
            this.modificar_contrato = this.modificar_contrato_original;
            this.dialog_error = true;
            this.mensaje_error = response.data.response;
          }
        } catch (error) {
          this.modificar_contrato = this.modificar_contrato_original;
          this.dialog_error = true;
          this.mensaje_error = "Error al actualizar el contrato";
        }
      };
    },

    confirmarDialogo() {
      if (this.accion_pendiente) {
        this.accion_pendiente();
      }
      this.dialog_mensaje_contrato = false;
      this.accion_pendiente = null;
    },

    cancelarDialogo() {
      this.modificar_contrato = this.modificar_contrato_original;
      this.dialog_mensaje_contrato = false;
      this.accion_pendiente = null;
    },

    modificar() {
      if (this.modificar_formulario) {
        this.loading_modificar = true;
        let params = {
          cliente_id: localStorage.getItem("id"),
          contrasena: this.cliente.contrasena,
        };
        service
          .modificarCliente(params)
          .then((response) => {
            this.loading_modificar = false;
            if (response.data.response_flag == 1) {
              this.modificar_formulario = false;
              this.show_password = false;
              this.dialog_mensaje = true;
              this.titulo = "Correcto";
              this.mensaje = "Se modificado correctamente la contraseña";
            } else {
              this.dialog_mensaje = true;
              this.titulo = "Problemas";
              this.mensaje = "Hubo un error en el servidor, contactar a encargado de sitio";
            }
          })
          .catch(() => {
            this.loading_modificar = false;
            this.dialog_mensaje = true;
            this.titulo = "Problemas";
            this.mensaje = "Hubo un error en el servidor, contactar a encargado de sitio";
          });
      } else {
        this.modificar_formulario = true;
        this.show_password = true;
        this.$refs.txtContrasena.focus();
      }
    },

    initialize() {
      this.modificar_contrato_original = this.cliente.contrato == 1 ? true : false;
      this.modificar_contrato = this.modificar_contrato_original;
      
      let params = {
        cliente_id: localStorage.getItem("id"),
      };
      
      service
        .consultarFolios(params)
        .then((response) => {
          this.loader = false;
          this.initializationComplete = true;
          
          if (response.data.response_flag == 1) {
            this.cantidad_guias = response.data.response.guias_disponibles;
          }
          
          this.tryStartTour();
        })
        .catch(() => {
          this.loader = false;
          this.initializationComplete = true;
          this.dialog_error = true;
          this.mensaje_error = "Hubo un error en el servidor, contactar a encargado de sitio";
          this.tryStartTour();
        });
    },

    iniciarTourContrato() {
      const driverObj = driver({
        showProgress: false,
        allowClose: false,
        animate: false,

        nextBtnText: 'Continuar <i class="mdi mdi-arrow-right"></i>',
        prevBtnText: '<i class="mdi mdi-arrow-left"></i> Anterior',
        doneBtnText: 'Finalizar <i class="mdi mdi-check"></i>',

        steps: [
          {
            element: "#switch-contrato",
            popover: {
              title: "Impresión con contrato",
              description: "Desde este interruptor puedes activar o desactivar la impresión automática del contrato.",
              side: "bottom",
              align: "start",
              onNextClick: (element, opts) => {
                this.titulo = "Confirmar cambio";
                this.mensaje = "¿Deseas cambiar el estado de aceptación del contrato?";
                this.dialog_mensaje_contrato = true;
                
                this.$nextTick(() => {
                  setTimeout(() => {
                    driverObj.refresh();
                    driverObj.moveNext();
                  }, 400);
                });
              }
            }
          },
          {
            element: "#dialog-confirmacion-contrato",
            popover: {
              title: "Confirmación",
              description: "El sistema solicitará confirmación antes de guardar el cambio.",
              side: "top",
              align: "center"
            },
            onHighlightStarted: (element) => {
              if (!element) {
                driverObj.moveNext();
              }
            }
          }
        ],
        onDestroyed: () => {
          this.dialog_mensaje_contrato = false;
          this.accion_pendiente = null;
          localStorage.setItem("tour_completado", "1");
          localStorage.removeItem("tour_contrato");
        },
        onElementHighlighted: (element, opts) => {
          if (!element) {
            console.warn('Driver.js: Elemento no encontrado, saltando paso');
            driverObj.moveNext();
          }
        }
      });

      this.$nextTick(() => {
        driverObj.drive();
      });
    }
  },
};
</script>